import { inject } from '@angular/core';
import { QarepaApiLinks, QarepaApiResponse } from '@qarepa/common';
import { OAuthStorageService } from '@qaroni-app/auth/services/o-auth-storage.service';
import { CommonsHttpService } from '@qaroni-core/services/commons/commons-http/commons-http.service';
import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export class QaroniIntermediate {
  protected commons = inject(CommonsHttpService);
  protected storage = inject(OAuthStorageService);

  protected validations = this.commons.validationsHttp;
  protected errors = this.commons.errorsHttp;

  protected readonly linksSubject = new Subject<QarepaApiLinks | null>();
  protected readonly messageSubject = new Subject<string>();

  public hasOAuth = this.storage.hasOAuth;

  protected status200 = <T>(response: QarepaApiResponse<T>) =>
    this.validations.verifyStatus200(response);

  protected status201 = <T>(response: QarepaApiResponse<T>) =>
    this.validations.verifyStatus201(response);

  protected status204 = <T>(response: QarepaApiResponse<T>) =>
    this.validations.verifyStatus204(response);

  public getLinks$() {
    return this.linksSubject.asObservable().pipe(shareReplay(1));
  }

  public getMessage$() {
    return this.messageSubject.asObservable().pipe(shareReplay(1));
  }
}
